<template>
  <follower-page
    :data="data"
    :loaded="loaded"
    :loadErr="loadErr"
  ></follower-page>
</template>
<script>
import followerPage from "./index.vue";
export default {
  components: {
    followerPage,
  },
  data() {
    return {
      data: [],
      loading: false,
      loaded: false,
      loadErr: false,
    };
  },
  computed: {
    reportDataId() {
      return this.$route.query.reportDataId;
    },
  },
  methods: {
    getReportMessage() {
      this.loading = true;
      this.$store
        .dispatch("getReportMessage", this.reportDataId)
        .then((res) => {
          this.data = res && res.examination;
          this.loading = false;
          this.loaded = true;
        })
        .catch((err) => {
          this.loading = false;
          this.loadErr = true;
        });
    },
  },
  created() {
    this.getReportMessage();
  },
};
</script>

<style module lang="less"></style>
